import React, { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className={isMenuOpen ? 'menu-open' : ''}>
      <div className="logo-center">
        <a href="/" className="logo-text">Baby Bolle</a>
      </div>

      <button className="hamburger" onClick={toggleMenu} aria-label="Toggle menu">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={`nav-container ${isMenuOpen ? 'active' : ''}`}>
        <nav className="nav-left">
          <a href="/" onClick={() => setIsMenuOpen(false)}>Idroterapia</a>
          <a href="/" onClick={() => setIsMenuOpen(false)}>Massaggi</a>
          <a href="/" onClick={() => setIsMenuOpen(false)}>Benefici</a>
          <a href="/" onClick={() => setIsMenuOpen(false)}>Corsi</a>
          <a href="/" onClick={() => setIsMenuOpen(false)}>Buoni Regalo</a>
        </nav>
        
        <div className="nav-right">
          <a href="/" onClick={() => setIsMenuOpen(false)}>Accedi</a>
          <a href="/" className="header-btn" onClick={() => setIsMenuOpen(false)}>Prenota Ora</a>
        </div>
      </div>
    </header>
  );
};

export default Header;
